import { PURCHASE_TYPES } from '../..';
import { TableDisplayable } from '../decorators';

@TableDisplayable('getName')
export default class PurchaseType {
	id: PURCHASE_TYPES;
	name: string;
	abbrev: string;

	toJSON() {
		return {
			id: this.id,
			name: this.name,
			abbrev: this.abbrev,
		};
	}

	constructor(props?: Partial<PurchaseType>) {
		Object.assign(this, props);
	}

	getName() {
		return this.name;
	}
}
